// Predefined marker icon definitions for fleet vehicle markers
// Each icon is a 24x24 viewBox SVG defined as stroke-based paths and circles.
// Rendered on HTML Canvas via ctx.stroke(new Path2D(d)) and ctx.arc().

export const MARKER_STYLES = [
  { key: 'arrow', label: 'settings.markerArrow' },
  { key: 'colored', label: 'settings.markerColored' },
  { key: 'ring', label: 'settings.markerRing' },
];

export const MARKER_ICONS = [
  // ── Vehicles (directional) ──────────────────────────────────────
  {
    key: 'car',
    label: 'mapIcon.car',
    category: 'vehicle',
    directional: true,
    paths: [
      // Body shell
      'M5 16V9.5L7 5h10l2 4.5V16H5z',
      // Roof / cabin
      'M7.5 9.5L9 7h6l1.5 2.5H7.5z',
      // Wheels
      'M7 16v1.5h2.5V16M14.5 16v1.5H17V16',
    ],
    circles: [],
  },
  {
    key: 'sedan',
    label: 'mapIcon.sedan',
    category: 'vehicle',
    directional: true,
    paths: [
      // Long low body
      'M4 15V10l2-4h12l2 4v5H4z',
      // Windshield line
      'M7 10l1.5-3h7L17 10',
      // Trunk line
      'M4 12h16',
      // Wheels
      'M6.5 15v2h3v-2M14.5 15v2h3v-2',
    ],
    circles: [],
  },
  {
    key: 'suv',
    label: 'mapIcon.suv',
    category: 'vehicle',
    directional: true,
    paths: [
      // Tall boxy body
      'M5 17V8l1-3h12l1 3v9H5z',
      // Roof rack
      'M6 5h12',
      // Window line
      'M6.5 8.5l1.5-2.5h8l1.5 2.5',
      // Window divider
      'M12 6v2.5',
      // Wheel arches
      'M6.5 17v1.5h3V17M14.5 17v1.5h3V17',
    ],
    circles: [],
  },
  {
    key: 'pickup',
    label: 'mapIcon.pickup',
    category: 'vehicle',
    directional: true,
    paths: [
      // Cab (front half)
      'M5 16V9l2-4h5v7H5z',
      // Windshield
      'M7 9l1.5-3h3.5',
      // Open bed (rear half)
      'M12 12h7v4h-7',
      // Bed sides
      'M12 9h7v3',
      // Wheels
      'M7 16v2h2.5v-2M15 16v2h2.5v-2',
    ],
    circles: [],
  },
  {
    key: 'van',
    label: 'mapIcon.van',
    category: 'vehicle',
    directional: true,
    paths: [
      // Tall box body
      'M4 17V7.5L6 4h8l2 3.5v1H18v8.5H4z',
      // Windshield
      'M6.5 7.5L8 5h4l1 2.5',
      // Cargo area divider
      'M4 10h14',
      // Rear doors
      'M16 10v7M18 10v7',
      // Wheels
      'M6 17v1.5h3v-1.5M15 17v1.5h3v-1.5',
    ],
    circles: [],
  },
  {
    key: 'bus',
    label: 'mapIcon.bus',
    category: 'vehicle',
    directional: true,
    paths: [
      // Long rectangular body
      'M4 18V5h16v13H4z',
      // Windows row
      'M5 7h14v4H5z',
      // Window dividers
      'M8 7v4M11 7v4M14 7v4M17 7v4',
      // Door
      'M5 12v5h3v-5',
      // Wheels
      'M6 18v1.5h3V18M15 18v1.5h3V18',
    ],
    circles: [],
  },
  {
    key: 'truck',
    label: 'mapIcon.truck',
    category: 'vehicle',
    directional: true,
    paths: [
      // Cab
      'M4 16V8l2-4h5v12H4z',
      // Windshield
      'M6.5 8l1.5-3h3',
      // Cargo box
      'M11 6h9v10h-9z',
      // Wheel wells
      'M5.5 16v2h3v-2M14 16v2h3v-2',
    ],
    circles: [],
  },
  {
    key: 'semi',
    label: 'mapIcon.semi',
    category: 'vehicle',
    directional: true,
    paths: [
      // Cab (compact)
      'M3 16V8.5L5 5h4v11H3z',
      // Cab windshield
      'M5.5 8.5L7 6h2',
      // Trailer (long)
      'M9 5.5h12v10.5H9z',
      // Trailer lines
      'M9 8h12',
      // Wheels (3 axles)
      'M4.5 16v2h2.5v-2M13 16v2h2.5v-2M17 16v2h2.5v-2',
    ],
    circles: [],
  },
  {
    key: 'tanker',
    label: 'mapIcon.tanker',
    category: 'vehicle',
    directional: true,
    paths: [
      // Cab
      'M3 16V9l2-4h4v11H3z',
      // Cab windshield
      'M5.5 9L7 6h2',
      // Cylindrical tank (elliptical shape)
      'M9 8c0-2 2-3 6-3s6 1 6 3v5c0 2-2 3-6 3s-6-1-6-3V8z',
      // Tank band
      'M9 11h12',
      // Wheels
      'M4.5 16v2h2.5v-2M14 16v2h2.5v-2M18 16v2h2.5v-2',
    ],
    circles: [],
  },
  {
    key: 'motorcycle',
    label: 'mapIcon.motorcycle',
    category: 'vehicle',
    directional: true,
    paths: [
      // Frame / body line
      'M8 11l4-5 4 5',
      // Handlebar
      'M9 7h6',
      // Seat
      'M9 12h6l1 1H8l1-1z',
      // Fender / engine
      'M12 6v5',
      // Wheel connectors
      'M8 13v2M16 13v2',
    ],
    circles: [
      // Front wheel
      { cx: 8, cy: 17, r: 2.5 },
      // Rear wheel
      { cx: 16, cy: 17, r: 2.5 },
    ],
  },
  {
    key: 'taxi',
    label: 'mapIcon.taxi',
    category: 'vehicle',
    directional: true,
    paths: [
      // Body (same as car base)
      'M5 17V10l2-4.5h10l2 4.5v7H5z',
      // Windshield
      'M7.5 10L9 7h6l1.5 3',
      // Taxi sign on roof
      'M9.5 4.5h5v2.5h-5z',
      // Wheels
      'M7 17v1.5h2.5V17M14.5 17v1.5H17V17',
    ],
    circles: [],
  },
  {
    key: 'tow_truck',
    label: 'mapIcon.towTruck',
    category: 'vehicle',
    directional: true,
    paths: [
      // Cab
      'M4 17V9l2-4h5v12H4z',
      // Windshield
      'M6.5 9L8 6h3',
      // Flatbed
      'M11 12h9v5h-9',
      // Boom / crane arm
      'M13 12V7l5 2v3',
      // Hook
      'M18 9v2',
      // Wheels
      'M5.5 17v2h3v-2M15 17v2h3v-2',
    ],
    circles: [],
  },

  // ── Service / Industrial (directional) ──────────────────────────
  {
    key: 'ambulance',
    label: 'mapIcon.ambulance',
    category: 'service',
    directional: true,
    paths: [
      // Van body
      'M4 17V8l2-4h8l2 3v1h3l1 2v7H4z',
      // Windshield
      'M6.5 8L8 5h5l1 3',
      // Cross symbol
      'M16 8v4M14 10h4',
      // Divider
      'M14 5v12',
      // Wheels
      'M6 17v2h3v-2M16 17v2h3v-2',
    ],
    circles: [],
  },
  {
    key: 'fire_truck',
    label: 'mapIcon.fireTruck',
    category: 'service',
    directional: true,
    paths: [
      // Cab
      'M3 17V9l2-4h4v12H3z',
      // Cab windshield
      'M5.5 9L7 6h2',
      // Body
      'M9 6h10v11H9z',
      // Ladder on top
      'M10 4h8M10 4v2M18 4v2',
      'M11 4h0M13 4h0M15 4h0M17 4h0',
      // Compartments
      'M9 12h10M13 6v11',
      // Wheels
      'M4.5 17v2h3v-2M14 17v2h3v-2',
    ],
    circles: [],
  },
  {
    key: 'police',
    label: 'mapIcon.police',
    category: 'service',
    directional: true,
    paths: [
      // Body (car shape)
      'M5 17V10l2-4.5h10l2 4.5v7H5z',
      // Windshield
      'M7.5 10L9 7h6l1.5 3',
      // Light bar on roof
      'M8 4.5h3v2.5H8zM13 4.5h3v2.5h-3z',
      // Hood badge line
      'M10 13h4',
      // Wheels
      'M7 17v1.5h2.5V17M14.5 17v1.5H17V17',
    ],
    circles: [],
  },
  {
    key: 'excavator',
    label: 'mapIcon.excavator',
    category: 'service',
    directional: true,
    paths: [
      // Cab
      'M5 14V9h6v5H5z',
      // Cab roof
      'M5 9h6V7H5',
      // Boom arm
      'M11 10l5-5',
      // Stick
      'M16 5l3 4',
      // Bucket
      'M18 8l2 2-2 1-1-2',
      // Track body
      'M3 14h12v4H3z',
      // Track wheels
      'M4 18h10',
    ],
    circles: [
      { cx: 5, cy: 18, r: 1.5 },
      { cx: 13, cy: 18, r: 1.5 },
    ],
  },
  {
    key: 'forklift',
    label: 'mapIcon.forklift',
    category: 'service',
    directional: true,
    paths: [
      // Body / cab
      'M8 17V8h7v9H8z',
      // Overhead guard
      'M8 6h7v2H8z',
      // Mast (front)
      'M6 5v12',
      // Forks
      'M4 17h2M4 15h2',
      // Seat
      'M12 10h2v3h-2',
      // Wheels
      'M9.5 17v2h2v-2M13 17v2h2v-2',
    ],
    circles: [
      { cx: 6, cy: 18, r: 1 },
    ],
  },
  {
    key: 'crane',
    label: 'mapIcon.crane',
    category: 'service',
    directional: true,
    paths: [
      // Base truck body
      'M4 17V12h14v5H4z',
      // Cab
      'M4 12V9h5v3',
      // Windshield
      'M5 10.5h3',
      // Crane turntable
      'M11 12V10h4v2',
      // Boom
      'M13 10L8 3',
      // Cable
      'M8 3v3',
      // Outriggers
      'M3 17h2M19 17h2',
      // Wheels
      'M6 17v2h3v-2M15 17v2h3v-2',
    ],
    circles: [],
  },

  // ── Non-vehicle (non-directional) ───────────────────────────────
  {
    key: 'person',
    label: 'mapIcon.person',
    category: 'other',
    directional: false,
    paths: [
      // Body
      'M12 10v5',
      // Arms
      'M9 12.5h6',
      // Left leg
      'M12 15l-2.5 5',
      // Right leg
      'M12 15l2.5 5',
    ],
    circles: [
      // Head
      { cx: 12, cy: 7, r: 3 },
    ],
  },
  {
    key: 'phone',
    label: 'mapIcon.phone',
    category: 'other',
    directional: false,
    paths: [
      // Phone body (rounded rectangle)
      'M8 2h8a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z',
      // Screen
      'M8 5h8v13H8z',
      // Home button area
      'M10.5 20h3',
      // Speaker
      'M10 3.5h4',
    ],
    circles: [],
  },
];

/**
 * Resolve a device's attributes to a marker configuration.
 * Handles both the new mapMarkerStyle/mapMarkerIcon attributes
 * and the legacy mapMarker/mapIcon attributes.
 */
export function resolveMarkerConfig(attrs = {}) {
  // New attribute format (mapMarkerStyle + mapMarkerIcon)
  if (attrs.mapMarkerStyle) {
    return {
      style: attrs.mapMarkerStyle,
      icon: attrs.mapMarkerIcon || null,
      customUrl: attrs.mapMarkerIcon === 'custom' ? attrs.mapIcon : null,
    };
  }
  // Legacy attribute format (mapMarker=icon + mapIcon=url)
  if (attrs.mapMarker === 'icon' && attrs.mapIcon) {
    return { style: 'colored', icon: 'custom', customUrl: attrs.mapIcon };
  }
  // Default: directional arrow
  return { style: 'arrow', icon: null, customUrl: null };
}

/**
 * Look up an icon definition by key.
 * @param {string} iconKey - The icon key (e.g. 'car', 'truck', 'person')
 * @returns {object|null} The icon definition or null if not found
 */
export function getIconDef(iconKey) {
  return MARKER_ICONS.find((i) => i.key === iconKey) || null;
}
